import {
  parseAsString,
  parseAsArrayOf,
  useQueryStates,
} from '@vrplatform/query-params';
import { hasValue } from '@vrplatform/utils';
import { useCallback } from 'react';

export const useExtractModal = () => {
  const [{ extractConnectionIds, extractType }, setExtract] = useQueryStates({
    extractConnectionIds: parseAsArrayOf(parseAsString),
    extractType: parseAsString,
  });

  const close = useCallback(() => setExtract(null), [setExtract]);

  const open = useCallback(
    ({
      connectionIds,
      extractType,
    }: {
      connectionIds: string[];
      extractType: string | undefined;
    }) => setExtract({ extractConnectionIds: connectionIds, extractType }),
    [setExtract]
  );

  const ids = extractConnectionIds?.filter(hasValue) || [];

  return {
    opened: !!ids.length,
    close,
    open,
    data: { extractType, extractConnectionIds: ids },
  };
};
